import { render, staticRenderFns } from "./KbvFilter.vue?vue&type=template&id=501f800e"
import script from "./KbvFilter.vue?vue&type=script&lang=ts"
export * from "./KbvFilter.vue?vue&type=script&lang=ts"
import style0 from "./KbvFilter.vue?vue&type=style&index=0&id=501f800e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports